import React from 'react';
import { UploadDragger, Form } from '@common/components';
type Props = {
  required: boolean;
  disabled?: boolean;
  multiple?: boolean;
};

export function ComplianceItemUploadInput({
  required = false,
  disabled = false,
  multiple = false,
}: Props) {
  const draggerProps = {
    name: 'file',
    action: '',
    text: 'Drag files to upload',
    beforeUpload() {
      return false;
    },
    maxCount: multiple ? undefined : 1,
  };

  return (
    <Form.Item
      label="Document Upload"
      name="files"
      valuePropName="file"
      key="files"
      rules={[
        {
          required,
          message: 'Please upload an attachment for this document.',
        },
      ]}
    >
      <UploadDragger {...draggerProps} multiple={multiple} disabled={disabled}>
        <p className="ant-upload-text">{draggerProps.text}</p>
      </UploadDragger>
    </Form.Item>
  );
}
